import * as echarts from 'echarts';

import type { ThemeColorModes } from '@atlaskit/tokens';

/***
 * ECharts is rendered on <canvas />, that do not support CSS variabales.
 * Used hardcoded values for tokens given in the comments.
 * labelLine and itemStyle have constant non-token value by the design.
 *
 * Alternatievly getTokenValue() with ThemeMutationObserver could be used,
 * but this would unnecessarily complicate the code.
 */

type CustomEChartsTheme = typeof LIGHT_THEME;

export const LIGHT_THEME = {
  axisPointer: {
    shadowStyle: {
      //--ds-background-neutral-hovered
      color: '#091E4224',
    },
  },
  tooltip: {
    textStyle: {
      //--ds-text
      color: '#172B4D',
    },
    //--ds-surface-hovered
    backgroundColor: '#F1F2F4',
    borderColor: '#F1F2F4',
  },
  valueAxis: {
    splitLine: {
      lineStyle: {
        //--ds-border
        color: '#091E4224',
      },
    },
  },
  textStyle: {
    //--ds-text
    color: '#172B4D',
  },
  title: {
    textStyle: {
      //--ds-text
      color: '#172B4D',
    },
  },
  legend: {
    textStyle: {
      //--ds-text
      color: '#172B4D',
    },
  },
  label: {
    //--ds-text
    color: '#172B4D',
  },
  labelLine: {
    lineStyle: {
      // no token
      color: '#6093BF',
    },
  },
  itemStyle: {
    // no token
    borderColor: '#d0e4f5',
  },
};

export const DARK_THEME: CustomEChartsTheme = {
  axisPointer: {
    shadowStyle: {
      //--ds-background-neutral-hovered
      color: '#A6C5E229',
    },
  },
  tooltip: {
    textStyle: {
      //--ds-text
      color: '#C7D1DB',
    },
    //--ds-surface-hovered
    backgroundColor: '#1D2125',
    borderColor: '#1D2125',
  },
  valueAxis: {
    splitLine: {
      lineStyle: {
        //--ds-border
        color: '#A6C5E229',
      },
    },
  },
  textStyle: {
    //--ds-text
    color: '#C7D1DB',
  },
  title: {
    textStyle: {
      //--ds-text
      color: '#C7D1DB',
    },
  },
  legend: {
    textStyle: {
      //--ds-text
      color: '#C7D1DB',
    },
  },
  label: {
    //--ds-text
    color: '#C7D1DB',
  },
  labelLine: {
    lineStyle: {
      // no token
      color: '#6093BF',
    },
  },
  itemStyle: {
    // no token
    borderColor: '#d0e4f5',
  },
};

type ThemeMapper = { [key in ThemeColorModes]: CustomEChartsTheme };

const ThemeMapper: ThemeMapper = {
  light: LIGHT_THEME,
  dark: DARK_THEME,
  auto: LIGHT_THEME,
};

export const registerEChartsThemes = (): void => {
  Object.entries(ThemeMapper).forEach(
    ([themeColorModeKey, themeColorModeValue]) => {
      echarts.registerTheme(themeColorModeKey, themeColorModeValue);
    }
  );
};
